import { Badge } from "ant-design-vue";
const { ...other } = Badge;
const YwBadge = {
  ...other,
  name: "YwBadge",
};

YwBadge.install = function (Vue) {
  Vue.component(YwBadge.name, YwBadge);
};

export default YwBadge;